import React from "react";
import LeadsTable from "./LeadsTable";
import LeftSidebar from "../LeftSidebar/LeftSidebar";

function Index() {
    return (
        <div className="max-w-8xl mx-auto grid grid-cols-1 lg:grid-cols-8">
            <LeftSidebar />
            <div className="lg:col-span-7 lg:px-8 lg:pr-[3.5rem]">
                <LeadsTable />
            </div>
        </div>
    );
}

export default Index;

